import store from '../store'
import Vue from 'vue'

getVersion().then(version => {
  if (localStorage.getItem('upatedV') === 'true') {
    setTimeout(() => {
      Vue.notify({
        message: `🎉️ Sopheo Actualizado 🎉️`,
        icon: 'mdi-cellphone-arrow-down',
        color: 'success'
        // type: 'success'
      })
      localStorage.setItem('upatedV', '')
    }, 4000)
  }
  if (localStorage.getItem('version') !== version) {
    localStorage.setItem('version', version)
    localStorage.setItem('upatedV', 'true')
    setTimeout(() => {
      location.reload(true)
    }, 100)
  }

  let config = {
    AppName: 'Sopheo',
    version: version
  }
  let apiUrlPlugin = {
    install (Vue) {
      Vue.apiUrl = buildUrlApi
      Vue.prototype.$apiUrl = buildUrlApi
      Vue.prototype.$config = config
    }
  }
  Vue.use(apiUrlPlugin)

  function buildUrlApi (controller, api) {
    let url = store.getters['api/getUrl'](api, controller)
    if (api) Vue.axios.defaults.headers['Api'] = api.charAt(0).toUpperCase() + api.slice(1)
    return url.toLowerCase()
  }
})

async function getVersion () {
  const FETCH_TIMEOUT = 5000
  let didTimeOut = false
  let version = null
  try {
    await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        didTimeOut = true
        reject(new Error('Request timed out'))
      }, FETCH_TIMEOUT)
      fetch('config.json?' + Date.now())
        .then(response => {
          clearTimeout(timeout)
          if (!didTimeOut) {
            response.json().then(json => {
              version = json.version
              resolve(response)
            })
          }
        })
        .catch(err => {
          if (didTimeOut) return
          reject(err)
        })
    })
      .then(() => {})
      .catch(err => console.error('promise error! ', err))
  } catch (e) {
    console.error('Error on Get Public IP:', e)
  }
  return version
}
